import { ReactNode } from 'react';
import { Navigate } from 'react-router';
import { useAiChatAccessState } from '~/hooks/useFeatureFlag';
import { RouteConfig } from '~/routes/routeConfig';
import AiChatSellingPage from '~/views/chat/AiChatSellingPage';

interface AiChatSellingGuardProps {
  children: ReactNode;
}

const AiChatSellingGuard: React.FC<AiChatSellingGuardProps> = ({ children }) => {
  const accessState = useAiChatAccessState();

  switch (accessState) {
    case 'chat':
      return children;
    case 'selling':
      return <AiChatSellingPage />;
    case 'none':
      return <Navigate replace to={RouteConfig.AppRoot.buildLink()} />;
  }
};

export default AiChatSellingGuard;
